/**
 * Velora Chat (web). No sidebar section: one chat icon in the top bar (with
 * the unread count) opens a resizable drawer on the right, like Ask Velora,
 * and `/chat` is the full page. The user menu always lists Chat too, so a
 * crowded or phone-width top bar still reaches it, and the Dentrix-style
 * modes list it in the Velora menu and the toolbar (`chat.open`).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'chat',
    title: 'Velora Chat',
    version: '0.1.0',
    owner: 'WP5-CHAT',
    entitlementKey: null,
    permissions: ['chat.use'],
    routes: [{ id: 'chat', path: '/chat', title: 'Chat', officeScope: 'practice' }],
    commands: [
      {
        id: 'chat.page',
        title: 'Open Velora Chat',
        keywords: ['chat', 'message', 'team', 'coworker', 'dm', 'channel'],
        routeId: 'chat',
      },
    ],
  }),
  pages: {
    chat: () => import('./ChatPage.js'),
  },
});
